import * as React from 'react';
import { Modal, Button, ConfigProvider, toast } from '@cloud/atom-ui';
//@ts-ignore
import  './style.m.less';
import '@cloud/atom-ui/lib/input/style/index';
import UploadFile from './HandleImportFile';
import TransferPerson from './TransferPerson';
import SelectMainPage from './SelectMainPage';
import {
  addPermission,
  downloadPermissionList,
  getPermission,
  transderToPermissionData,
  transferFromPermissionData,
  getDomainScopes
} from './utils/permisson';
import * as nls from './nls';
//@ts-ignore
import {i18n} from '@src/utils/i18n';
//@ts-ignore
import lang from '@src/utils/lang';
const language = lang.lang;

import { useDebounceFn } from './utils/utils';
const I18N = i18n(nls);
let selectTmpList = [];
const t = (key)=>{
 return I18N[key];
};
export default React.forwardRef((props: any, ref: any) => {
  const {
    params: {
      ifUseModal = false,
      isReverses = '2',
      boxTitle = {
        // 左右侧显示的标题
        leftTitle: t('ToSelect'),
        rightTitle: t('Selected'),
      },
      transferPersonSetting = {
        transferTabList: ['Organization', 'Role', 'UserGroup', 'Admin'], // 配置选人组件可以选择哪些内容
        ifUseTabList: true,
        ifSelectDept: true,
        deptOnly: false,
        noPermission: false,
        useSelectAll: false,
        searchPlaceholder: t('DefaultSelectPersonSearchPlaceholder'),
      },
      mainPageSetting = {
        useMainPage: true, // 是否显示主控面板
        useDisplayArea: true, // 是否显示已选面板
        useChooseModeRadio: true, // 是否显示调整全选和部分选择的按钮
        useFucButtonGroup: true, // 是否显示功能按钮组
        useConfirmButtonGroup: true, // 是否显示确认按钮组
        useSelectTips: true, // 是否显示选择提示语句
        ifVertical: true, // 全选和部分选择是否为竖直排列
        distenBetween: '3px', // 全选按钮与部分选择按钮之间的间距
        showAreaMaxWidth: 550, // 展示已选区域的宽度设置
      },
      appTag = {
        // 调用设置可见范围的模块名或者应用名
        objectId: 'objectId_test',
        namespace: 'appaccess',
        objectName: '打卡',
        action: 'common-read',
      },
      CmpToShowModel = ({ handelClick } = props) => (
        <div className={"settings"} onClick={handelClick}>
          设置
        </div>
      ),
      myRef,
    },
    isDeveloper = false,
    handlePersonOk,
  } = props;
  const [useModal, setUseModal] = React.useState(ifUseModal);
  const [mainVisible, setMainVisible] = React.useState(false);
  const [importListVisible, setImportListVisible] = React.useState(false);
  const [selectPersonVisible, setSelectPersonVisible] = React.useState(false);
  const [mode, setMode] = React.useState('SomeCanSee');
  const [selectedList, setSelectedList] = React.useState([]);
  const [origSelectedList, setOrigSelectedList] = React.useState([]);
  const [mainLoading, setMainLoading] = React.useState(false);
  const [judeTipRender, setJudeTipRender] = React.useState(false)
  // 改变选人模式 mode = AllCanSee 为选择全部； SomeCanSee 为部分选择
  const modeOnChange = (e) => {
    setMode(e.target.value);
  };

  const showAllEmployeesRef = React.useRef(true)

  // 通过ref方法向外暴露方法
  React.useImperativeHandle(myRef, () => ({
    showExcelModal() {
      setImportListVisible(true);
    },
    showSelectPersonModal() {
      setSelectPersonVisible(true);
    },
    async confirmSelectedData() {
      return await handleMainOk();
    },
    getPermissionExcel() {
      downloadPermissionList(appTag, language);
    },
    getPermissionInfo() {
      return [...origSelectedList];
    },
    getSelectedData() {
      return [...selectedList];
    },
    setSelectedData(tmpData) {
      setSelectedList(tmpData);
    },
  }));

  // 可见范围部分函数
  const showMainModal = useDebounceFn(
    () => {
      if(isDeveloper) {
        reFeshData();
        setUseModal(true);
      } else {
        toast(t('OnlyDataRange'));
      }
    },
    1000,
    true,
  );

  // 将选好的人员数据固化
  const handleMainOk = useDebounceFn(
    (e) => {
      return new Promise((resolve) => {
        setMainLoading(true);
        if (mode === 'SomeCanSee' && selectedList.length === 0) {
          setMainLoading(false);
          toast(t('ErrorTipsNoEmployee'));
          resolve('fail');
        } else if (mode === 'SomeCanSee' && selectedList.length > 500) {
          setMainLoading(false);
          toast(t('ErrorTipsLimmit'));
          resolve('fail');
        } else if (mode === 'SomeCanSee' && dataEqual(selectedList, origSelectedList)) {
          setMainLoading(false);
          toast(t('ErrorTipsNoChange'));
          resolve('fail');
        } else {
          //@ts-ignore
          addPermission('select', transderToPermissionData(appTag, mode, selectedList, isReverses)).then((data) => {
            setMainLoading(false);
            toast(t('SaveSuccess'));
            setMainVisible(false);
            resolve('success');
            handlePersonOk(transderToPermissionData(appTag, mode, selectedList, isReverses));
          });
        }
      });
    },
    1000,
    true,
  );

  // 取消操作，将对话框启动的主页面隐藏
  const handleMainCancel = useDebounceFn(
    (e) => {
      if (useModal === false) {
        reFeshData();
        toast('已重置修改');
      } else {
        setMainVisible(false);
      }
    },
    1000,
    true,
  );

  // 选人标签相关函数
  // 取消某个标签的选择
  const handleTagClose = (removedTag) => {
    const tags = selectedList.filter((tag) => tag !== removedTag.info);
    setSelectedList(tags);
  };

  // 选人框确认选择
  const handleSelectPersonOk = (e) => {
    selectTmpList.push({ title: '' });
    setSelectedList([...selectTmpList]);
    setTimeout(() => {
      selectTmpList.pop();
      setSelectedList([...selectTmpList]);
      setSelectPersonVisible(false);
    });
  };

  // 选人框取消选择
  const handleSelectPersonCancel = (e) => {
    setSelectPersonVisible(false);
  };

  const reFeshData = React.useCallback(() => {
    getPermission(appTag).then((data) => {
      let tmpData: any = transferFromPermissionData(data, language, t);
      if (tmpData !== 'all-login-user') {
        setMode('SomeCanSee');
        setOrigSelectedList([...tmpData]);
        tmpData.push({ title: '' });
        setSelectedList(tmpData);
        setTimeout(() => {
          tmpData.pop();
          setSelectedList(tmpData);
        });
      } else {
        setOrigSelectedList([]);
        setSelectedList([]);
        setMode(showAllEmployeesRef.current ? 'AllCanSee' : 'SomeCanSee');
      }
      setMainVisible(true);
    });
  }, [appTag, language, t]);

  React.useEffect(() => {
    setUseModal(ifUseModal);
  }, [ifUseModal]);

  React.useEffect(() => {
    if(!mainVisible) return;
    reFeshData();
  }, [reFeshData]);

  React.useEffect(()=>{
    getDomainScopes().then(res=>{
      if(res.status === 1){
        // @ts-ignore
        const isAll = res.data.includes('all');
        showAllEmployeesRef.current = isAll;
        setMode('SomeCanSee');
      }
    })
  },[])

  const renderTip = ()=>{
    return (
      judeTipRender && (
        <span className='text'>仅全局管理员可以指定角色</span>
      )
    );
  }
  const changeUseTabList = (flag:boolean)=>{
    setJudeTipRender(flag)
  }

  return (
    <ConfigProvider autoInsertSpaceInButton={false}>
      <div>
        {/* 页面部分 */}
        {/* 使用对话框的方式 */}
        {/* 设置可见范围主菜单 */}
         {mainPageSetting.useMainPage &&
          (
            <>
              <CmpToShowModel handelClick={showMainModal} />
              {/*@ts-ignore*/}
              <Modal
                wrapClassName="medium-modal"
                title={t('SetDataRange')}
                visible={mainVisible}
                onOk={handleMainOk}
                onCancel={handleMainCancel}
                footer={[
                  <div className={"modalFooter"} key={'tips'}>
                    <span className={'btnTitle'}>{t('SelectTipsOK')}</span>
                    <div>
                      <Button
                        key="submit"
                        type="primary"
                        size={'small'}
                        loading={mainLoading}
                        onClick={(e) => handleMainOk(e)}
                      >
                        {t('Confirm')}
                      </Button>
                      <Button key="Cancel" size={'small'} onClick={(e) => handleMainCancel(e)}>
                        {t('Cancel')}
                      </Button>
                    </div>
                  </div>,
                ]}
              >
                <SelectMainPage
                  useModal={true}
                  onChange={modeOnChange}
                  mode={mode}
                  appTag={appTag}
                  setSelectPersonVisible={setSelectPersonVisible}
                  setImportListVisible={setImportListVisible}
                  selectedList={selectedList}
                  handleTagClose={handleTagClose}
                  mainPageSetting={mainPageSetting}
                  mainLoading={mainLoading}
                  handleMainOk={handleMainOk}
                  handleMainCancel={handleMainCancel}
                  origSelectedList={origSelectedList}
                  setSelectedList={setSelectedList}
                  showAllEmployees={showAllEmployeesRef.current}
                />
              </Modal>
            </>
          )}

        {/* 导入名单菜单 */}
        {importListVisible && (
          <UploadFile
            importListVisible={importListVisible}
            setImportListVisible={setImportListVisible}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
            reFeshData={reFeshData}
            appTag={appTag}
          ></UploadFile>
        )}

        {/* 选人组件 */}

        {selectPersonVisible && (
          /*@ts-ignore*/
          <Modal
            title={t("AddPerson")}
            width={800}
            visible={selectPersonVisible}
            onOk={handleSelectPersonOk}
            onCancel={handleSelectPersonCancel}
            footer={[
              <div className={"modalFooter"}>
                <span className={"btnTitle"}>{renderTip()}</span>
                <div>
                  <Button
                    key="submit"
                    type="primary"
                    size={"small"}
                    style={{ fontSize: 14 }}
                    onClick={e => handleSelectPersonOk(e)}
                  >
                    {t("Confirm")}
                  </Button>
                  <Button
                    key="cancel"
                    size={"small"}
                    style={{ fontSize: 14 }}
                    onClick={e => handleSelectPersonCancel(e)}
                  >
                    {t("Cancel")}
                  </Button>
                </div>
              </div>
            ]}
          >
            <TransferPerson
              params={{
                selectedList,
                getList: list => {
                  selectTmpList = [...list];
                },
                boxTitle: boxTitle,
                transferTabList: transferPersonSetting.transferTabList,
                ifUseTabList: transferPersonSetting.ifUseTabList,
                ifSelectDept: transferPersonSetting.ifSelectDept,
                deptOnly: transferPersonSetting.deptOnly,
                noPermission: transferPersonSetting.noPermission,
                ifUseSelectAll: transferPersonSetting.useSelectAll,
                onlyStaticUserGroup: transferPersonSetting.onlyStaticUserGroup,
                searchPlaceholder: transferPersonSetting.searchPlaceholder,
                changeUseTabList:changeUseTabList
              }}
              
            />
          </Modal>
        )}
      </div>
    </ConfigProvider>
  );
});

const dataEqual = (data1, data2) => {
  let flag = true;
  if (data1 === data2) {
    return true;
  } else if (data1.length !== data2.length) {
    return false;
  }
  data1.forEach((item, index) => {
    if (item.key !== data2[index].key) {
      flag = false;
      return false;
    }
  });
  return flag;
};
